"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordForm = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("../../theme");

var _basis = require("basis");

var _ = require("./..");

var _getValidation = require("../../utils/getValidation");

// @ts-ignore
var PasswordForm = function PasswordForm(props) {
  var fieldProps = props.fieldProps,
      loading = props.loading,
      onSubmit = props.onSubmit,
      onGoBack = props.onGoBack;
  var fieldID = fieldProps.fieldID,
      name = fieldProps.name,
      description = fieldProps.description,
      validation = fieldProps.validation;
  var theme = (0, _theme.useTheme)();

  var handleSubmit = function handleSubmit(state) {
    if (Object.keys(state.errors).length) {
      return;
    }

    onSubmit(state.values[fieldID]);
  };

  return /*#__PURE__*/_react.default.createElement(_.Form, {
    id: "password",
    initialValues: (0, _defineProperty2.default)({}, fieldID, ''),
    onSubmit: handleSubmit
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_.FormLayout, null, /*#__PURE__*/_react.default.createElement(_basis.Input, {
      name: fieldID,
      testId: fieldID,
      label: name,
      type: "password",
      helpText: description,
      validate: (0, _getValidation.getValidation)(validation),
      disabled: loading,
      color: theme.inputColor
    }), /*#__PURE__*/_react.default.createElement(_.FormButtonsLayout, null, /*#__PURE__*/_react.default.createElement(_.SubmitButton, {
      loading: loading
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "password.buttonSubmit"
    })), /*#__PURE__*/_react.default.createElement(_basis.Button, {
      variant: "secondary",
      onClick: onGoBack
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "password.buttonBack"
    }))));
  });
};

exports.PasswordForm = PasswordForm;